import * as React from "react";
import { useEffect } from "react";
import classnames from "classnames";
import { useAppContext } from "../Contexts/AppContext";
import "./Toast.scss";

export interface IToast {
    position: number[];
    title: string;
    text?: string;
    classname?: string;
}

export const Toast = (): JSX.Element => {
    const { showToast, setShowToast } = useAppContext();

    useEffect(() => {
        showToast && setTimeout(() => setShowToast(undefined), 900);
    }, [showToast]);

    const style = showToast
        ? {
              left: showToast.position[0] + "px",
              top: showToast.position[1] + "px"
          }
        : {};

    return (
        <div id="toast" className={classnames(showToast?.classname, { show: showToast })} style={style}>
            {showToast?.title && <div>{showToast.title}</div>}
            {showToast?.text && <div>{showToast.text}</div>}
        </div>
    );
};
